import React, { useEffect } from "react";
import HelpSection from "../../../../components/dashboardcomponents/KnowledgeBase/KnowledgeBaseLangingPage/HelpSection";
import ArticleGrid from "../../../../components/dashboardcomponents/KnowledgeBase/KnowledgeBaseLangingPage/ArticleGrid";
import ArticleListKnowledgeBase from "../../../../components/dashboardcomponents/KnowledgeBase/KnowledgeBaseLangingPage/ArticleListKnowledgeBase";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchfeatureArticlesExternal } from "../../../../store/features/getFeatureArticleExternal";
import { getExternalArticleByCategory } from "../../../../store/features/getExternalArticleByCategory";
import { getAllExternalKbCategories } from "../../../../store/features/getExternalAllCategories";
import { getTenantSlug, isKbSubdomain } from "../../../../utils";
import { getKbGroupId } from "../../../../utils/kbGroupId";

const KnowledgeBaseCategoryPage = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { slug: categorySlugFromUrl } = useParams();
  const { data: kbSettings, initialized } = useSelector((state) => state.externalKbSettings);
  const businessName = getTenantSlug() || location.state?.tenantSlug;
  const groupId = getKbGroupId();

  const categorySlug = categorySlugFromUrl || location.state?.category?.slug || "";
  const passedCategory = location.state?.category;

  const { articles: featuredArticles, loading: featuredLoading } = useSelector(
    (state) => state.featuredArticlesExternal
  );

  const { data, loading } = useSelector((state) => state.externalArticleByCategory);
  const articles = data?.data?.articles || [];

  // 👇 NEW: pull all categories from Redux
  const { data: categoriesData } = useSelector((state) => state.externalCatgroiesKb);
  const allCategories = categoriesData?.data || [];

  // 👇 NEW: find current category by slug from API data
  const fetchedCategory = allCategories.find((cat) => cat.slug === categorySlug);

  // 👇 NEW: prefer API data → fallback to location.state (works in local)
  const resolvedCategory = fetchedCategory || passedCategory;
  const categoryName = resolvedCategory?.name || "Knowledge Base";
  // const subCategories =
  //   resolvedCategory?.children?.length > 0
  //     ? [
  //       { name: resolvedCategory.name, slug: resolvedCategory.slug },
  //       ...resolvedCategory.children,
  //     ]
  //     : [];

  useEffect(() => {
    if (!businessName || !categorySlug || !groupId) {
      console.warn("Missing businessName, categorySlug, or groupId", { businessName, categorySlug, groupId });
      return;
    }

    // fetch categories if not cached
    if (allCategories.length === 0) {
      dispatch(getAllExternalKbCategories({ businessName, group_id: groupId }));
    }

    // fetch featured articles only if not already loaded
    if (!featuredArticles || featuredArticles.length === 0) {
      dispatch(fetchfeatureArticlesExternal({ businessName, group_id: groupId }));
    }

    dispatch(
      getExternalArticleByCategory({
        businessName,
        categorySlug,
        group_id: groupId,
      })
    );
  }, [dispatch, businessName, categorySlug, groupId]);

  const handleSubCategoryClick = (subSlug) => {
    if (!businessName || !subSlug || !groupId) return;
    dispatch(
      getExternalArticleByCategory({
        businessName,
        categorySlug: subSlug,
        group_id: groupId,
      })
    );
  };

  const handleArticleClick = (articleSlug) => {
    if (isKbSubdomain()) {
      navigate(`/${articleSlug}`);
    } else {
      navigate(`/kb/view/${articleSlug}`, {
        state: { businessName }
      });
    }
  };

  return (
    <>
      <HelpSection
        onSearchShow={false}
        title={categoryName}
        productName={
          kbSettings?.data?.business_name
            ? kbSettings.data.business_name.charAt(0).toUpperCase() + kbSettings.data.business_name.slice(1)
            : 'Trustchat'
        }
        description="New to Trustchat? Get to know the basics here "
      />

      <ArticleListKnowledgeBase
        // subCategories={subCategories}
        loading={loading}
        articles={articles.map((a) => ({
          id: a._id,
          title: a.title,
          slug: a.slug,
        }))}
        onSubCategoryClick={handleSubCategoryClick}
        onArticleClick={handleArticleClick}
      />

      <ArticleGrid
        loading={featuredLoading}
        articles={featuredArticles}
        businessName={businessName}
        title="Featured Articles"
      />
    </>
  );
};

export default KnowledgeBaseCategoryPage;